<template>
  <div class="doctor-manage">
    <div class="main-content">
      <div class="page-title clearfix">
        <div class="float-left">
          <span>{{ $t("nav.doctor") }}</span>
          <span class="total-num">{{ totalCount }}</span>
        </div>
        <div class="float-right">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            @click="showAddPopover"
          >
            {{ $t("doctor.add") }}
          </button>
          <!-- <button type="button" class="btn btn-primary btn-sm ml10" @click.stop="handleShowManagerPopover">批量设置权限</button> -->
        </div>
      </div>
      <div class="doctor-content">
        <div class="search-wrapper">
          <span class="search-btn" @click.stop="handleSearch">{{
            $t("search")
          }}</span>
          <el-form
            :inline="true"
            :model="searchForm"
            class="search-form"
            size="small"
          >
            <el-form-item :label="$t('doctor.department')">
              <el-select
                v-model="searchForm.department_id"
                @change="getDoctorData"
                clearable
                placeholder=""
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('student.doctor')">
              <el-input
                v-model="searchForm.doctor_name"
                clearable
                placeholder=" "
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tabel-content">
          <el-table
            ref="multipleTable"
            :data="doctorList"
            :empty-text="$t('no_data')"
            style="width: 100%"
            header-row-class-name="thead-dark"
          >
            <el-table-column
              prop="doctor_name"
              :label="$t('student.doctor') + '(' + $t('sign.username') + ')'"
            >
              <template v-slot="scope">
                <span>
                  {{ scope.row.doctor_name }} ({{ scope.row.username }})
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="department_name"
              :label="$t('student.department')"
            ></el-table-column>
            <el-table-column
              prop="student_count"
              :label="$t('doctor.student_count')"
            ></el-table-column>
            <el-table-column
              prop="project_count"
              :label="$t('doctor.project_count')"
            ></el-table-column>
            <el-table-column
              prop="patient_count"
              :label="$t('doctor.patient_count')"
            ></el-table-column>
            <el-table-column
              prop="date_updated"
              :label="$t('doctor.update_time')"
            ></el-table-column>
            <el-table-column :label="$t('doctor.status')">
              <template v-slot="scope">
                <span>{{ scope.row.status | formatStatus }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column :label="$t('doctor.right')">
              <template v-slot="scope">
                <router-link
                  :to="{ name: 'doctorAuthority', query: { id: scope.row.id, name: scope.row.doctor_name, department: scope.row.department_name, department_id: scope.row.department_id } }"
                  >{{ $t("doctor.edit_right") }}</router-link
                >
              </template>
            </el-table-column> -->
            <el-table-column :label="$t('operate')" align="center" width="150">
              <template v-slot="scope">
                <span
                  class="cursor text-primary mr10"
                  @click="showEditPopover(scope.row)"
                  >{{ $t("doctor.modify") }}</span
                >
                <span
                  class="cursor text-danger"
                  @click="handleDeleteDoctor(scope.row.id)"
                  >{{ $t("delete") }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="clearfix mt-3 mb-3">
        <div class="float-left">
          <pagination
            v-if="totalCount > 0"
            :pageSize="pageSize"
            :layout="layout"
            :currentPage="currentPage"
            :total="totalCount"
            @goToPage="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <edit-model
      :showPopover="showPopover"
      :doctor="doctor"
      :popoverTitle="popoverTitle"
      :departmentList="departmentList"
      :isAdd="isAdd"
      :reportTypeList="reportTypeList"
      :allReportTemplates="allReportTemplates"
      @closePopover="closePopover"
      @submitDoctor="submitDoctor"
    >
    </edit-model>
  </div>
</template>

<script>
import {
  doctorListRequest,
  addDoctorRequest,
  editDoctorRequest,
  deleteDoctor,
  departmentListRequest,
  report_types,
} from "../../api/api";
import editModel from "../../components/doctor/editModel";
import pagination from "../../components/pager";
import { paginationMixin } from "../../utils/mixin";
import { MessageBox, Loading } from "element-ui";
import { mapState, mapGetters } from "vuex";

let _that;

export default {
  mixins: [paginationMixin],
  components: {
    editModel,
    pagination,
  },
  data() {
    return {
      searchForm: {
        doctor_name: "",
        department_id: "",
      },
      doctorList: [],
      departmentList: [],
      showPopover: false,
      doctor: {},
      popoverTitle: "",
      popoverType: "",
      isAdd: true,
      showSearchDrawer: false,
      value1: "",
      clearable: false,
      showManagerPopover: false,
      pageSize: 15,
      currentPage: 1,
      totalCount: 0,
      reportTypeList: [], //报告类型列表
      allReportTemplates: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  mounted() {
    //监听键盘esc事件
    document.addEventListener("keyup", this.handleKeyup);
  },
  beforeDestroy() {
    //监听键盘esc事件
    document.removeEventListener("keyup", this.handleKeyup);
  },
  created() {
    this.getReportTypes();
    this.getDoctorData();
    this.getDepartmentList();
  },
  methods: {
    //监听键盘esc事件
    handleKeyup(event) {
      if (event.key === "Escape") {
        //console.log("Esc key pressed");
        // 执行你的逻辑
        this.closePopover();
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.pageSize = 15;
      this.getDoctorData();
    },
    showSearchWrapper() {
      this.showSearchDrawer = true;
    },
    hideSearchWrapper() {
      this.showSearchDrawer = false;
    },
    async getDoctorData() {
      this.doctorList = [];
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        ...this.searchForm,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      try {
        let res = await doctorListRequest(params);
        if (res.status === 200) {
          this.doctorList = res.data.length > 0 ? res.data : [];
          this.totalCount = res.total || 0;
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    async getDepartmentList() {
      let params = {
        page: 1,
        pageSize: 1000000,
      };
      try {
        let res = await departmentListRequest(params);
        if (res.status === 200) {
          this.departmentList = res.data.length > 0 ? res.data : [];
        } else {
          this.departmentList = [];
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getReportTypes() {
      try {
        let res = await report_types();
        if (res.status === 200 && res.data.length) {
          console.log(res.data);
          res.data.forEach((item) => {
            item.template = parseInt(item.template);
          });
          this.reportTypeList = res.data;
          this.allReportTemplates = res.data.map((item) => item.template);
        } else {
          this.reportTypeList = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    showAddPopover() {
      this.doctor = {
        department_id: this.user.department_id || "",
        limits: {
          report: "disable",
          report_templates: [],
        },
        reportEnable: false,
      };
      this.popoverTitle = this.$t("doctor.add");
      this.showPopover = true;
      this.popoverType = "add";
      this.isAdd = true;
    },
    showEditPopover(doctor) {
      console.log("showEditPopover", doctor.limits);
      let reportDisable =
        doctor.limits &&
        doctor.limits.report &&
        doctor.limits.report == "disable"
          ? true
          : false;

      console.log("showEditPopover", reportDisable);
      let templates =
        doctor.limits && doctor.limits.report_templates
          ? doctor.limits.report_templates
          : [];

      let limits = {
        report: reportDisable ? "disable" : "enable",
        report_templates: templates,
      };

      this.doctor = {
        id: doctor.id,
        doctor_name: doctor.doctor_name,
        department_id: doctor.department_id,
        email: doctor.email,
        password: doctor.password || "",
        username: doctor.username,
        title: doctor.title,
        telephone: doctor.telephone,
        limits: limits,
      };

      console.log("showEditPopover", this.doctor);

      this.popoverTitle = this.$t("doctor.edit_doctor");
      this.showPopover = true;
      this.popoverType = "edit";
      this.isAdd = false;
    },
    closePopover() {
      this.doctor = {};
      this.popoverTitle = "";
      this.showPopover = false;
      this.popoverType = "";
    },
    submitDoctor(doctor) {
      if (this.popoverType === "add") {
        this.handleAddDoctor(doctor);
      } else if (this.popoverType === "edit") {
        this.handleEditDoctor(doctor);
      }
    },
    async handleAddDoctor(doctor) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let res = await addDoctorRequest(doctor);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getDoctorData();
          this.closePopover();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    async handleEditDoctor(doctor) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      let params = {
        id: doctor.id,
        department_id: doctor.department_id,
        doctor_name: doctor.doctor_name,
        email: doctor.email,
        password: doctor.password,
        username: doctor.username,
        telephone: doctor.telephone,
        title: doctor.title,
        limits: doctor.limits,
      };
      try {
        let res = await editDoctorRequest(params);
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getDoctorData();
          this.closePopover();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    handleDeleteDoctor(id) {
      MessageBox.confirm(this.$t("notice.p_confirm"), this.$t("notice.tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      })
        .then(() => {
          this.deleteDoctor(id);
        })
        .catch(() => {});
    },
    async deleteDoctor(id) {
      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let res = await deleteDoctor({ id: id });
        if (res.status === 200) {
          this.$helper.successNotify(res.message);
          this.getDoctorData();
        } else {
          this.$helper.errNotify(res.message);
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDoctorData();
    },
    handleShowManagerPopover() {
      this.showManagerPopover = true;
    },
    handleHideManagerPover() {
      this.showManagerPopover = false;
    },
  },
  beforeCreate() {
    _that = this;
  },
  filters: {
    formatStatus: function (status) {
      switch (status) {
        case "0":
          return _that.$t("student.close");
        case "1":
          return _that.$t("student.open");
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  border-bottom: 1px solid #dee2e6;
}
.doctor-manage {
  .el-checkbox {
    margin-bottom: 0;
  }
  .form-item {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
